declare global {
  interface Window {
    opera: string;
    MSStream: unknown;
  }
}

// Implementation of getMobileOperatingSystem from https://stackoverflow.com/a/21742107
export const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    // window.MSStream - windows phone sometimes have ios user agent
    return 'ios';
  }

  return 'android';
};
